
































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Multiselect from 'vue-multiselect';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars, faSave, faTimes } from '@fortawesome/free-solid-svg-icons'
import constants from '@/utils/constants';

library.add(faBars, faSave, faTimes)

@Component({
  components: {
    Multiselect,
  }
})
export default class PaymentMethodPopup extends Vue {
  @Prop({ default: false }) showModal?: boolean;
  @Prop() data!: any;

  $swal: any;
  selectOption: any = null;
  options = [
    {
      group: 'Online',
      list: [
        { text: 'QRIS Gopay', value: 'Qris-GoPay' },
        { text: 'QRIS Shopee pay', value: 'Qris-ShopeePay' },
        { text: 'QRIS AstraPay', value: 'Astrapay' },
        { text: 'QRIS CIMB', value: 'QRPay' },
        { text: 'Pay At Hotel', value: 'Pay At Hotel' },
      ],
    },
    {
      group: 'Offline',
      list: [
        { text: 'Cash', value: 'Cash' },
        { text: 'CIMB QR Static', value: 'CIMB QR Static' },
        { text: 'QR - BCA', value: 'QR - BCA' },
        { text: 'Voucher Event', value: 'Voucher Event' },
        { text: 'Voucher ASRI', value: 'Voucher ASRI' },
        { text: 'Debit BCA', value: 'Debit BCA' },
        { text: 'Debit Mandiri', value: 'Debit Mandiri' },
      ],
    },
    {
      group: 'EDC Online',
      list: [
        { text: 'QRIS Ottopay', value: 'QR' },
        { text: 'Debit Card', value: 'DEBITCARD' },
        { text: 'Credit Card', value: 'CREDITCARD' },
      ],
    },
    {
      group: 'EDC Offline',
      list: constants.EDC_OFFLINE_PAYMENT_OPTIONS.map(item => ({
        text: item.text,
        value: item.value,
      })),
    },
  ]

  get updateOrderDetail() {
    return this.$store.getters.GetUpdateOrderDetail;
  }

  @Watch('updateOrderDetail.isSuccess')
  watchOrderDetailSuccess() {
    if (this.updateOrderDetail.isSuccess) {
      const payload = {
        orderId: this.data.orderId,
        paymentMethod: this.selectOption ? this.selectOption.value : '',
      };
      this.$store.commit('UPDATE_ORDER_DETAIL', payload);
      this.$emit('call-back', payload);
      this.$swal(
        constants.SUCCESS_MESSAGE,
        'Order Updated',
        constants.STATUS_SUCCESS
      );
    }
  }

  @Watch('updateOrderDetail.error')
  watchOrderDetailError() {
    if (this.updateOrderDetail.error) {
      this.$swal(
        constants.SOMETHING_WROING,
        this.updateOrderDetail.error,
        constants.STATUS_ERROR
      );
    }
  }

  scrollToSelected() {
    this.$nextTick(() => {
      if (this.$refs['paymentMethodSelect'] && this.selectOption) {
        const selectComponent: any = this.$refs['paymentMethodSelect'];
        if (selectComponent.$el) {
          const selectedOption = selectComponent.$el.querySelector('.multiselect__option--selected');
          if (selectedOption) {
            selectedOption.scrollIntoView({ block: 'nearest' });
          }
        }
      }
    });
  }

  reset() {
    const flatOptions = this.options.flatMap(group => group.list);
    this.selectOption = flatOptions.find(item => item.value === this.data.paymentMethod) || null;
  }

  discardModal() {
    this.reset();
    this.$emit('discard-modal');
  }

  saveData() {
    if (this.updateOrderDetail.isUpdating) return;
    this.$validator.validateAll().then(async(valid) => {
      if (valid) {
        this.$store.dispatch('UpdateOrderDetail', {
          orderId: this.data.orderId,
          paymentMethod: this.selectOption ? this.selectOption.value : '',
        });
      }
    })
  }
};
